import { StatProps, Text, UsdPriceTextWithTooltip } from "@bridgesplit/ui";
import { formatPercent, formatUsd } from "@bridgesplit/utils";
import { VaultDepositsAggregate } from "@bridgesplit/abf-react";
import { COPY } from "app/constants";

import { PortfolioTableStats, RewardPoint } from "./common";
import { useActivePortfolioRewardsSummary } from "./util";

export default function LendVaultStats({ aggregate }: { aggregate: VaultDepositsAggregate | undefined }) {
    const portfolioRewards = useActivePortfolioRewardsSummary();
    const loading = !aggregate || !portfolioRewards || portfolioRewards.isLoading;

    // Standardized section-stats order: Total value → APY → Daily interest → Daily rewards.
    const stats: StatProps[] = [
        {
            value: (
                <UsdPriceTextWithTooltip textColor="body" rawUsdValue={aggregate?.totalValueUsd} loading={loading} />
            ),
            caption: COPY.TOTAL_SUPPLIED_TERM
        },
        {
            value: formatPercent(aggregate?.wAvgTotalApy),
            caption: COPY.APY_TERM
        },
        {
            value: <Text translate="no">{formatUsd(aggregate?.expected24hInterestUsd)}</Text>,
            caption: COPY.DAILY_INTEREST_TERM
        },
        {
            value: <RewardPoint points={portfolioRewards?.data?.activeLendVaultDailyPoints ?? 0} variant="body1" />,
            caption: COPY.DAILY_REWARDS_TERM
        }
    ];

    return <PortfolioTableStats stats={stats} loading={loading} />;
}
